import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LuciTreeTableComponent } from './luci-tree-table.component';
import {FormsModule} from '@angular/forms';
import {LuciDropdownModule} from '../luci-dropdown/luci-dropdown.module';
import {LuciPaginationModule} from '../luci-pagination/luci-pagination.module';
import {LuciSearchModule} from '../luci-search/luci-search.module';
import {TreeFilterPipeModule} from '../commons/pipes/tree-filter-pipe/tree-filter-pipe.module';
import {SearchFilterPipeModule} from '../commons/pipes/search-filter/search-filter.pipe.module';
import {ColumnFilterModule} from '../commons/pipes/column-filter/column-filter.module';
import {LuciToolbarModule} from '../luci-toolbar/luci-toolbar.module';
import {GlobalSearchFilterModule} from '../commons/pipes/global-search-filter/global-search-filter.module';
import {NgDragDropModule} from 'ng-drag-drop';
import {LuciButtonModule} from '../luci-button/luci-button.module';



@NgModule({
  declarations: [LuciTreeTableComponent],
  exports: [LuciTreeTableComponent],
  imports: [
    CommonModule,
    FormsModule,
    ColumnFilterModule,
    SearchFilterPipeModule,
    TreeFilterPipeModule,
    LuciDropdownModule,
    LuciPaginationModule,
    LuciSearchModule,
    LuciButtonModule,
    LuciToolbarModule,
    GlobalSearchFilterModule,
    NgDragDropModule.forRoot()
  ]
})
export class LuciTreeTableModule { }
